const routeConstant = {
  landingPage: "landing-page",
  login: "login",
  signup: "signup",
  dashboard: "/",
  swipeFiles: "/swipe-ad",
  archiveFiles: "/archive-files",
  discovery: "/explore-lounge",
  team: "/team",
  help: "/help",
  error: "*",
  settings: "settings",
  starred: "/starred",
  forgotPassword: "forgot-password",
  verifyEmail: "verify-email",
  resetPassword: "reset-password",
  notification: "/notification",
  termsConditions: "/terms-conditions",
  privacyPolicy: "/privacy-policy",
  subscription: "/subscription",
  invitedMember: "/invited-member",
  subscriptionExpired: "/subscription-expired",
  paymentHistory: "/paymentHistory",
  adDetails: "/adDetails",
  myFolders: "/myFolders",
  sharedFolders: "/sharedFolders",
  teamFolders: "/teamFolders",
  paymentProcessing: "/payment/processing",
  paymentStatus: "/payment/status",
  paymentPreview: "/payment/preview",
  paymentCheckout: "/payment/checkout",
  redirect: "/payment/redirect",
  paymentMethods: "/payment-method",
  choosePaymentCard: "/payment-method/choose-card",
  updatePaymentMethodSuccess: "/payment-method/update/success",
  paymentLogs: "/payment/payment-logs",
  purchaseSeatLogs: "/payment/purchase-seat-logs",
};

export default routeConstant;
